<div class="flex flex-column align-items-center h-full gap-4 pr-4 pl-4">
  <img #logo src="logo1.svg" alt="Suburban Supply Logo" class="logo" />
  <h1 class="text-center text-xl">Welcome to Suburban Supply!</h1>
  @if (forbidden) {
    <div class="qb-error-wrapper">
      <div class="qb-error flex flex-column gap-2">
        <div class="text-sm flex gap-2">
          <i class="pi pi-exclamation-triangle"></i>
          <h4>Forbidden</h4>
        </div>
        <p class="text-sm pl-4 pr-4">You don't have the required role to access this resource</p>
      </div>
    </div>
  }
  <div class="mt-auto mb-6 w-full">
    @if (!forbidden) {
      <p-button [fluid]="true" size="large" label="Sign In" styleClass="login-btn" (click)="login()"></p-button>
    } @else {
      <p-button [fluid]="true" size="large" label="Go To Sign In" styleClass="login-btn" (click)="logout()"></p-button>
    }
  </div>
</div>
